import React, { useState, useEffect } from "react";

import { StyleSheet, View, Text, Platform } from "react-native";
import AppTheme from "../../AppTheme";

import MoodsList from "../../common/mood/MoodsList";
import ManaTextInput from "../../common/ManaTextInput";
import ReflectIcon from "../../common/icons/ReflectIcon";
import cardStyles from "../../home/cards/cardStyles";

export default function ReportOverralComment({
  report = {},
  saveNotes = () => {},
}) {
  const [note, setNote] = useState(report.comment);
  const [mood, setMood] = useState(report.mood);

  useEffect(() => {
    if (mood || note) {
      saveNotes({ mood, comment: note });
    }
  }, [note, mood]);

  return (
    <View style={[cardStyles.card, { minHeight: 50 }]}>
      <View
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          height: 34,
          paddinLeft: 9,
        }}
      >
        <ReflectIcon
          fillColor={AppTheme.almostBlack}
          fillColor2={AppTheme.almostBlack}
        />
        <Text style={[styles.title]}>Overall Comment</Text>
      </View>

      <MoodsList selectedMood={mood} onSelect={(m) => setMood(m)} />

      <ManaTextInput
        debounceDelay={500}
        name={"reportEditNote"}
        style={styles.input}
        multiline={true}
        numberOfLines={2}
        value={note || ""}
        onTextChanged={(text) => setNote(text)}
        placeholderTextColor="#9C9EB9"
        placeholder="Write some notes"
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginTop: 5,
  },
  title: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: "#333333",
    marginLeft: 6,
  },
  input: {
    width: "auto",
    minHeight: 55,
    paddingTop: 10,
    paddingHorizontal: 12,
    marginVertical: 8,
    marginHorizontal: 16,
    borderRadius: 4,
    backgroundColor: "#F3F2F1",
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.77,
    elevation: 3,
    color: AppTheme.almostBlack,
    shadowOpacity: 0,
  },
});
